"use client";

import Image from "next/image";

export interface SpeakerAvatar {
  name: string;
  image: string;
  imageAlt: string;
}

interface SpeakerAvatarsProps {
  speakers: SpeakerAvatar[];
  size?: number;
  className?: string;
}

export default function SpeakerAvatars({
  speakers,
  size = 40,
  className = "",
}: SpeakerAvatarsProps) {
  return (
    <ul className={`flex items-center list-none m-0 p-0 ${className}`}>
      {speakers.map((speaker, index) => (
        <li
          key={speaker.name}
          className="relative rounded-full ring-2 ring-white overflow-hidden bg-gray-100 shrink-0"
          style={{
            width: size,
            height: size,
            marginLeft: index === 0 ? 0 : Math.round(size * -0.32),
            zIndex: speakers.length - index,
          }}
        >
          <Image
            src={speaker.image}
            alt={speaker.imageAlt || speaker.name}
            width={size}
            height={size}
            className="object-cover w-full h-full"
          />
        </li>
      ))}
    </ul>
  );
}
